function getDecade(year: number): { min: number; max: number } {
  let i = year;

  while (i % 10) {
    i++;
  }

  return { min: i - 10, max: i };
}

function chunkByDecade({ min, max }: { min: number; max: number }): number[][] {
  const dates = [];

  for (let i = 0; i < 4; i++) {
    dates.push(
      new Array(3)
        .fill(0)
        .map((_, index) => i * 3 + min + index)
        .filter((year) => year <= max),
    );
  }

  return dates;
}

export { getDecade, chunkByDecade };
